<template>
<div>
<v-layout row wrap v-if="(url === 'localhost' || url.toLowerCase().indexOf('groundup') >= 0) && (email.includes('support@tibura.com') || email.includes('albert@gaserv.com'))" style="background:#b3d4fc">
  <div style="position:absolute;width:100vw;height:98vh;">
  <iframe width="100%" height="89%" :src="embedUrl" 
  frameborder="0" allowFullScreen="true">
  </iframe>
  </div>
  </v-layout>
<v-layout row wrap v-else>
  <v-flex xs12 md4 sm4 lg4 pa-2 pr-1 pl-2>
    <QuickPreview />
  </v-flex>
  <v-flex xs12 md8 sm6 lg8  pa-2>
    <v-layout row wrap>
      <v-flex xs12 pr-4>
        <StylesInWatch />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 pr-4>
      <Inventory />
      </v-flex>
      <v-flex xs12 pr-4>
      <InventoryBySeason />
      </v-flex>
    </v-layout>
   </v-flex>
</v-layout>
</div>
</template>
<script>
import QuickPreview from './QuickPreview.vue'
import Inventory from './Inventory.vue'
import InventoryBySeason from './InventoryBySeason.vue'
import StylesInWatch from './StylesInWatch.vue'

//import InventorySummary from './InventorySummary.vue'
//import WatchList from './WatchListData.vue'
export default {
  components: {
    QuickPreview,
    Inventory,
    InventoryBySeason ,
    StylesInWatch
  //  InventorySummary
},
  data () {
    return {
      due:{},
      url:window.location.hostname,
      email:JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.email,
      embedUrl:"https://app.powerbi.com/view?r=eyJrIjoiMWE1NzBkMmQtNjIzYS00NTVkLThhYTktZmRiMzIzMzYxODVkIiwidCI6IjM0YTA0ZWVjLTNhMDktNGNmMy1iNzY3LTljZjRmZGNhMDU5MCJ9&pageName=ReportSection"
    };
  },
  created(){
    console.log(window.location,"working")
    console.log(this.url=='localhost' || this.url.toLowerCase()=='groundup',"working");
    
  }

};
</script>   
<style >
.subheading-title {

font-family: Roboto;
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 19px;
/* identical to box height */

text-align: center;
letter-spacing: 0.03em;
text-transform: capitalize;

color: #545454;

mix-blend-mode: normal;
}
</style>